module.exports = __webpack_public_path__ + "img/academia_funcional.1403b73d.png";